import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Person = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M21.707 10.051C21.896 9.341 22 8.64 22 8C22 4.692 19.308 2 16 2C12.692 2 10 4.692 10 8C10 8.64 10.104 9.341 10.293 10.051C7.87 10.396 6 12.483 6 15V19C6 21.415 7.721 23.435 10 23.899V27C10 28.654 11.346 30 13 30H19C20.654 30 22 28.654 22 27V23.899C24.279 23.434 26 21.414 26 19V15C26 12.483 24.13 10.396 21.707 10.051ZM16 4C18.206 4 20 5.794 20 8C20 10.479 17.931 14 16 14C14.069 14 12 10.479 12 8C12 5.794 13.794 4 16 4ZM24 19C24 20.654 22.654 22 21 22C20.448 22 20 22.448 20 23V27C20 27.551 19.551 28 19 28H13C12.449 28 12 27.551 12 27V23C12 22.448 11.552 22 11 22C9.346 22 8 20.654 8 19V15C8 13.346 9.346 12 11 12H11.021C11.202 12.372 11.403 12.735 11.624 13.077C12.838 14.962 14.392 16 16 16C17.608 16 19.162 14.962 20.376 13.077C20.597 12.735 20.798 12.372 20.979 12H21C22.654 12 24 13.346 24 15V19V19Z" />
	</svg>
);

export default Person;
